import axios from 'axios'
import { ChangeEvent, Dispatch, SetStateAction } from 'react'
import { Slider } from '../../models/sliders'

type FormElement = ChangeEvent<HTMLInputElement>

export const useGeneralInfoForm = (type: number, sliderState: Slider, setSliderState: Dispatch<SetStateAction<Slider>>) => {
  const handleNumberChange = (inputName: string) => (_event: any, value: any) => {
    const newValue = value !== null ? value.id : null
    setSliderState({ ...sliderState, [inputName]: newValue })
  }

  const handleInputChangeFile = (event: FormElement) => {
    const files = event.target.files
    if (files && files.length > 0) {
      const file = files[0]
      setSliderState(prev => ({ ...prev, image: file }))
    }
  }

  const handleInputChange = (inputName: string, value: any) => {
    setSliderState({ ...sliderState, [inputName]: value })
  }

  const handleState = async (inputName: string, value: any) => {
    if (type === 1 && value !== null && value.length > 0) {
      try {
        const response = await axios.get(`${import.meta.env.VITE_API_URL}/sliders/countryorder/${value[0]}`)
        setSliderState({
          ...sliderState,
          [inputName]: value,
          order: response.data.order
        })
      } catch (error) {
        console.error('Error fetching country order:', error)
      }
    } else {
      setSliderState({ ...sliderState, [inputName]: value })
    }
  }

  return {
    handleNumberChange,
    handleInputChangeFile,
    handleInputChange,
    handleState
  }
}
